<script>
    //atribuindo o vue para criar o template
    import Vue from 'vue'

            // criação do template para fazer o loop e criar o menu dinamicado
            Vue.component('list-menu', {
                template: '<li v-if="line.linkexterno == false"><a :class="line.colorborder" :style="line.border" v-link="line.href"><i class="iconmenu" :class="line.icone"></i><span class="title principal">{{line.titulo}}{{line.quantidade}}</span></a><ul class="sub-menu" v-if="submenu"><list-menu v-for="item in line.children" :line="item"></list-menu></ul></li><li v-else ><a :class="line.colorborder" :style="line.border" :href="line.href" target="_blank"><i :class="line.icone"></i><span class="title">{{line.titulo}}{{line.quantidade}}</span></a></li>',
                props: {
                    line: Object
                },
                computed: {
                    submenu: function () {
                        //console.log(this.line.children && this.line.children.length)
                        //return true;
                        return this.line.children && this.line.children.length

                    }
                },
                ready() {

                }
            });


</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// listmenu.vue?3a8ccf04